// Custom
import actions from "./actions.json";
import columns from "./columns.json";
import common from "./common.json";
import components from "./components.json";
import customAuth from "./custom/auth.json";
import entity from "./entity.json";
import enums from "./enums.json";
import errors from "./error-codes.json";
import fields from "./fields.json";
import modals from "./modals.json";
import qrScanner from "./qr-scanner.json";
import routes from "./routes.json";
import shift from "./shift.json";

export const nlTranslations = {
  "error-codes": errors,

  // Custom translations
  "custom-auth": customAuth,
  common: common,
  fields: fields,
  columns: columns,
  entity: entity,
  actions: actions,
  routes: routes,
  modals: modals,
  enums: enums,
  shift: shift,
  components: components,
  "qr-scanner": qrScanner,
};
